import { render, staticRenderFns } from "./EsignPopupProvider.vue?vue&type=template&id=98b9fa9a&"
import script from "./EsignPopupProvider.vue?vue&type=script&lang=js&"
export * from "./EsignPopupProvider.vue?vue&type=script&lang=js&"
import style0 from "./EsignPopupProvider.vue?vue&type=style&index=0&id=98b9fa9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports